import React from 'react';
import { motion } from 'framer-motion';
import { HiLightBulb, HiOfficeBuilding, HiTrendingUp, HiUserGroup } from 'react-icons/hi';

const highlights = [
  { icon: HiOfficeBuilding, text: 'Fundada nos anos 90', color: '#3B9ED4' },
  { icon: HiLightBulb, text: 'Pioneira em TI na região', color: '#5BACD1' },
  { icon: HiUserGroup, text: '+30 anos de experiência', color: '#2178AB' },
  { icon: HiTrendingUp, text: 'Projetos em vários segmentos', color: '#6BBDDF' },
];

const variants = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      staggerChildren: 0.08,
    },
  },
};

const itemVariant = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0 },
};

function History() {
  return (
    <section id="history" className="section-padding" style={{ background: 'linear-gradient(180deg, #EBF6FC 0%, #FAFEFF 100%)' }}>
      <div className="container">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={variants}
        >
          <motion.div className="section-header text-center" variants={itemVariant}>
            <p
              style={{
                display: 'inline-flex',
                padding: '8px 14px',
                borderRadius: '9999px',
                background: 'rgba(59,158,212,0.08)',
                color: '#2178AB',
                fontWeight: 700,
                marginBottom: '18px',
              }}
            >
              Raiz local, entrega duradoura
            </p>
            <h2 className="section-title">História construída junto com empresas da região.</h2>
          </motion.div>

          <div className="row align-items-stretch" style={{ rowGap: '24px' }}>
            <div className="col-lg-7 col-md-12">
              <motion.article
                variants={itemVariant}
                style={{
                  background: 'linear-gradient(145deg, rgba(255,255,255,0.97) 0%, rgba(235,246,252,0.9) 100%)',
                  backdropFilter: 'blur(20px)',
                  borderRadius: '28px',
                  padding: '40px',
                  boxShadow: '0 16px 40px rgba(59,158,212,0.10)',
                  border: '1px solid rgba(59, 158, 212, 0.14)',
                  height: '100%',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: '-10%',
                    right: '-6%',
                    width: '180px',
                    height: '180px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(59,158,212,0.12) 0%, transparent 70%)',
                    pointerEvents: 'none',
                  }}
                />

                <h3
                  style={{
                    fontSize: '1.85rem',
                    marginBottom: '20px',
                    color: '#1A2D3A',
                    fontWeight: 800,
                    maxWidth: '14ch',
                  }}
                >
                  Ecosistemas Computação
                </h3>

                <p style={{ color: '#4A6680', lineHeight: 1.85, fontSize: '1.03rem', marginBottom: '18px' }}>
                  A empresa nasceu na década de noventa, quando informática ainda era exceção na cidade de Jardim-MS. Esse contexto moldou uma cultura de proximidade com o cliente e de leitura prática do problema.
                </p>

                <p style={{ color: '#4A6680', lineHeight: 1.85, fontSize: '1.03rem', marginBottom: '18px' }}>
                  O foco começou com formação em computação e evoluiu para desenvolvimento de sistemas, acompanhando o crescimento de empresas locais e do interior de Mato Grosso do Sul.
                </p>

                <p style={{ color: '#4A6680', lineHeight: 1.85, fontSize: '1.03rem' }}>
                  Esse histórico aparece no produto: menos discurso de software genérico e mais atenção ao fluxo de operação, implantação e suporte.
                </p>
              </motion.article>
            </div>

            <div className="col-lg-5 col-md-12">
              <motion.div
                variants={itemVariant}
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                  gap: '18px',
                  height: '100%',
                }}
              >
                {highlights.map((item) => {
                  const Icon = item.icon;

                  return (
                    <motion.article
                      key={item.text}
                      whileHover={{ y: -6, boxShadow: `0 18px 34px ${item.color}18` }}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: '14px',
                        padding: '24px 20px',
                        background: 'rgba(255,255,255,0.9)',
                        backdropFilter: 'blur(12px)',
                        borderRadius: '22px',
                        border: `1px solid ${item.color}24`,
                        boxShadow: '0 8px 20px rgba(59,158,212,0.08)',
                        minHeight: '170px',
                      }}
                    >
                      <div
                        style={{
                          width: '54px',
                          height: '54px',
                          background: `${item.color}18`,
                          border: `1px solid ${item.color}38`,
                          borderRadius: '16px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Icon size={24} color={item.color} />
                      </div>

                      <span style={{ color: '#1A2D3A', fontWeight: 700, fontSize: '1rem', lineHeight: 1.45 }}>
                        {item.text}
                      </span>
                    </motion.article>
                  );
                })}
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default History;
